import { useContext } from "react";
import ActiveItemDivider from "./ActiveItemDivider";
import { CraftPredictionContext } from "pages/CraftPrediction";

const ActiveItemIPredictionCraftSelect = ({ item }) => {
  const { selectItemHandler, playSound } = useContext(CraftPredictionContext);

  const selectHandler = (item) => {
    selectItemHandler(item);
    playSound("craftSelectItem");
  };

  if (item.type.toLowerCase() === "event" && item.is_valid_event === false) {
    return <ActiveItemDivider />
  }

  return (
    <>
      <button
        className="card-details__combine-action card-details__combine-action--select"
        onClick={() => selectHandler(item)}
      >
        Select
      </button>
      <ActiveItemDivider />
    </>
  );
};

export default ActiveItemIPredictionCraftSelect;
